const extractRoutesFromNested = (obj) => {
  const routes = [];

  const traverse = (current) => {
    if (!current) return;

    if (Array.isArray(current)) {
      current.forEach((item) => {
        traverse(item);
      });
    } else if (typeof current === "object" && current !== null) {
      if (current.route && typeof current.route === "string") {
        routes.push(current.route);
      }

      Object.values(current).forEach((value) => {
        traverse(value);
      });
    }
  };

  traverse(obj);
  return [...new Set(routes)];
};

export const extractRoutesFromResponse = (response) => {
  if (!response) {
    return [];
  }

  if (response.ui_access_routes) {
    return extractRoutesFromNested(response.ui_access_routes);
  }

  return extractRoutesFromNested(response);
};
